import React from 'react'
import { Button, ButtonGroup, Card, Badge, Modal, Form, Alert } from 'react-bootstrap'
import { FaPlus, FaCheck, FaFilePdf, FaFileImage, FaFileAlt, FaEye, FaTrashAlt, FaCarAlt, FaUpload } from 'react-icons/fa'
import { useStateAuthContext, useStateHostContext } from '../context';
import Swal from 'sweetalert2'

const Opd_alih_status_kendaraan_keluar = () => {
    const { STATE_AUTH } = useStateAuthContext();
    const { HOST } = useStateHostContext();
    const [data_alih_status, setData_alih_status] = React.useState([])
    const [data_kendaraan, setData_kendaraan] = React.useState([])
    const [data_opd, setData_opd] = React.useState([])
    const [daftar_kendaraan_teralih, setDaftarKendaraanTeralih] = React.useState([])
    const [expandedRow, setExpandedRow] = React.useState(null);
    const [viewType, setViewType] = React.useState(null); // 'kendaraan' or 'dokumen'
    const [loading, setLoading] = React.useState(false);
    const [showTransferModal, setShowTransferModal] = React.useState(false);
    const [showUploadModal, setShowUploadModal] = React.useState(false);
    const [showProsesMutasiModal, setShowProsesMutasiModal] = React.useState(false);
    const [currentUploadType, setCurrentUploadType] = React.useState('');
    const [currentAlihStatusId, setCurrentAlihStatusId] = React.useState('');
    const [uploadFile, setUploadFile] = React.useState(null);
    const [nomorSurat, setNomorSurat] = React.useState('');
    const [tglSurat, setTglSurat] = React.useState('');

    const [selectedOpd, setSelectedOpd] = React.useState('');
    const [selectedVehicles, setSelectedVehicles] = React.useState([]);
    const [reason, setReason] = React.useState('');
    const [currentItem, setCurrentItem] = React.useState(null);

    const handleGetData = React.useCallback(async () => {
        setLoading(true);
        try {
            const param = {
                method: 'GET',
                headers: {
                    'REST-TOKEN': STATE_AUTH.token,
                    'REST-ID-OPD': STATE_AUTH.id_opd
                }
            }
            const requ = await fetch(HOST + '/alih_status/ambil_berdasarkan_opd/keluar', param)
            const resp = await requ.json()

            if (requ.ok) {
                if (resp.s === true) {
                    setData_alih_status(resp.d)
                    setDaftarKendaraanTeralih(resp.d?.flatMap(item => item.daftar_kendaraan).map(k => k.id) || []);
                }
            }
        } catch (error) {
            console.log(error)
        } finally {
            setLoading(false);
        }
    }, [HOST, STATE_AUTH])

    const handleAmbilDataKendaraan = React.useCallback(async () => {
        const resp = await fetch(HOST + '/user/kendaraan', {
            method: 'GET',
            headers: {
                'REST-TOKEN': STATE_AUTH.token,
                'REST-ID-OPD': STATE_AUTH.id_opd
            }
        })
        const resu = await resp.json()
        setData_kendaraan(resu.d)
    }, [HOST, STATE_AUTH])

    const handleAmbilDataOpd = React.useCallback(async () => {
        const requ = await fetch(HOST + '/opd/ambil', {
            method: 'GET',
            headers: {
                'REST-TOKEN': STATE_AUTH.token,
                'REST-ID-OPD': STATE_AUTH.id_opd
            }
        })
        const resp = await requ.json()
        if (requ.ok && resp.s === true) {
            setData_opd(resp.d)
        }
    }, [HOST, STATE_AUTH])

    React.useEffect(() => {
        handleGetData()
        handleAmbilDataKendaraan()
        handleAmbilDataOpd()
    }, [handleAmbilDataKendaraan, handleAmbilDataOpd, handleGetData])

    const handleViewDocuments = (index, type) => {
        if (expandedRow === index && viewType === type) {
            setExpandedRow(null);
            setViewType(null);
        } else {
            // Otherwise, open the new view
            setExpandedRow(index);
            setViewType(type);
        }
    }

    const handleTransferSuccess = () => {
        handleGetData();
        setShowTransferModal(false);
    };

    const handleVehicleSelect = (vehicleId) => {
        if (selectedVehicles.includes(vehicleId)) {
            setSelectedVehicles(selectedVehicles.filter(id => id !== vehicleId));
        } else {
            setSelectedVehicles([...selectedVehicles, vehicleId]);
        }
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        // Check for required fields before showing confirmation
        if (!selectedVehicles.length) {
            alert('Pilih setidaknya satu kendaraan');
            return;
        }

        if (!selectedOpd) {
            alert('Pilih OPD tujuan');
            return;
        }

        if (!reason.trim()) {
            alert('Masukkan alasan pengalihan');
            return;
        }

        // Show confirmation dialog using SweetAlert2
        const result = await Swal.fire({
            title: 'Konfirmasi Pengalihan Kendaraan',
            text: `Apakah Anda yakin ingin mengajukan pengalihan ${selectedVehicles.length} kendaraan?`,
            icon: 'question',
            showCancelButton: true,
            confirmButtonColor: '#0d6efd',
            cancelButtonColor: '#dc3545',
            confirmButtonText: 'Ya, Ajukan',
            cancelButtonText: 'Batal'
        });

        if (result.isConfirmed) {
            // Show loading indicator using SweetAlert
            Swal.fire({
                title: 'Memproses...',
                text: 'Mohon tunggu sebentar',
                allowOutsideClick: false,
                allowEscapeKey: false,
                showConfirmButton: false,
                didOpen: () => {
                    Swal.showLoading();
                }
            });

            try {
                // Format selected vehicles as comma-separated string
                const vehicleIds = selectedVehicles.join(',');

                const fd = new FormData();
                fd.append('ID_KENDARAAN', vehicleIds);
                fd.append('ID_OPD_TUJUAN', selectedOpd);
                fd.append('ALASAN_PENGALIHAN', reason);

                const param = {
                    method: 'POST',
                    headers: {
                        'REST-TOKEN': STATE_AUTH.token,
                        'REST-ID-OPD': STATE_AUTH.id_opd
                    },
                    body: fd
                };

                const response = await fetch(HOST + '/alih_status/buat', param);
                const resultData = await response.json();

                Swal.close(); // Close the loading dialog

                if (response.ok && resultData.s) {
                    Swal.fire({
                        title: 'Berhasil!',
                        text: 'Pengalihan kendaraan berhasil diajukan.',
                        icon: 'success',
                        confirmButtonColor: '#0d6efd'
                    });
                    handleTransferSuccess();
                    handleReset();
                } else {
                    Swal.fire({
                        title: 'Gagal!',
                        text: resultData.m || 'Gagal mengajukan pengalihan kendaraan',
                        icon: 'error',
                        confirmButtonColor: '#0d6efd'
                    });
                }
            } catch (error) {
                console.error('Error submitting form:', error);
                Swal.close(); // Close the loading dialog
                Swal.fire({
                    title: 'Error!',
                    text: 'Terjadi kesalahan saat mengirim data',
                    icon: 'error',
                    confirmButtonColor: '#0d6efd'
                });
            }
        }
    };

    const handleReset = () => {
        setSelectedOpd('');
        setSelectedVehicles([]);
        setReason('');
    };

    const handleClose = () => {
        handleReset();
        setShowTransferModal(false);
    };

    const isDocumentComplete = (item) => {
        return (
            item.dok_permohonan_setda && item.no_surat_dok_permohonan_setda &&
            item.dok_ketersediaan_menerima && item.no_surat_dok_ketersediaan_menerima &&
            item.dok_persetujuan && item.no_surat_persetujuan &&
            item.dok_bast && item.no_surat_bast
        );
    };

    const getDocumentIcon = (documentUrl) => {
        if (!documentUrl) return null;

        const extension = documentUrl.split('.').pop().toLowerCase();

        if (extension === 'pdf') {
            return <FaFilePdf className="text-danger" size={100} />;
        } else if (['jpg', 'jpeg', 'png', 'gif'].includes(extension)) {
            return <FaFileImage className="text-primary" size={100} />;
        } else {
            return <FaFileAlt className="text-muted" size={100} />;
        }
    };

    const validateFileType = (file) => {
        if (!file) return false;

        const allowedTypes = ['application/msword', 'application/vnd.openxmlformats-officedocument.wordprocessingml.document', 'application/pdf'];
        const allowedExtensions = ['.doc', '.docx', '.pdf'];

        const fileType = file.type;
        const fileExtension = '.' + file.name.split('.').pop().toLowerCase();

        return allowedTypes.includes(fileType) || allowedExtensions.includes(fileExtension);
    };

    const handleOpenUploadModal = (alihStatusId, docType) => {
        setCurrentAlihStatusId(alihStatusId);
        setCurrentUploadType(docType);
        setNomorSurat('');
        setUploadFile(null);
        setShowUploadModal(true);
    };

    const handleCloseUploadModal = () => {
        setShowUploadModal(false);
        setCurrentAlihStatusId('');
        setCurrentUploadType('');
        setNomorSurat('');
        setUploadFile(null);
    };

    const handleOpenProsesMutasiModal = (item) => {
        setCurrentAlihStatusId(item.id_alih_status);
        setCurrentItem(item);
        setUploadFile(null);
        setShowProsesMutasiModal(true);
    };

    const handleCloseProsesMutasiModal = () => {
        setShowProsesMutasiModal(false);
        setCurrentAlihStatusId('');
        setUploadFile(null);
    };

    const handleFileChange = (e) => {
        const file = e.target.files[0];
        if (file) {
            if (validateFileType(file)) {
                setUploadFile(file);
            } else {
                alert('Format file tidak didukung. Silakan upload file dengan format: DOC, DOCX, atau PDF');
                e.target.value = null; // Reset the file input
            }
        }
    };

    const handleProsesMutasiFileChange = (e) => {
        const file = e.target.files[0];
        if (file) {
            if (validateFileType(file)) {
                setUploadFile(file);
            } else {
                alert('Format file tidak didukung. Silakan upload file dengan format: DOC, DOCX, atau PDF');
                e.target.value = null; // Reset the file input
            }
        }
    };

    const handleProsesMutasiSubmit = async (e) => {
        e.preventDefault();

        if (!uploadFile) {
            alert('Silakan pilih file BAST terlebih dahulu');
            return;
        }

        // Show loading indicator using SweetAlert
        Swal.fire({
            title: 'Mengupload dokumen BAST...',
            text: 'Mohon tunggu sebentar, dokumen BAST sedang diproses',
            allowOutsideClick: false,
            allowEscapeKey: false,
            showConfirmButton: false,
            didOpen: () => {
                Swal.showLoading();
            }
        });

        try {
            const formData = new FormData();
            formData.append('OPD_ASAL', data_opd.find(opd => opd.id === currentItem.id_opd_asal)?.opd || '');
            formData.append('OPD_TUJUAN', data_opd.find(opd => opd.id === currentItem.id_opd_tujuan)?.opd || '');
            formData.append('FILE_BAST', uploadFile); // BAST template
            formData.append('DATA_LAIN', JSON.stringify(currentItem));

            const param = {
                method: 'POST',
                headers: {
                    'REST-TOKEN': STATE_AUTH.token,
                    'REST-ID-OPD': STATE_AUTH.id_opd
                },
                body: formData
            };

            const response = await fetch(HOST + '/alih_status/proses_mutasi', param);
            const result = await response.json();

            Swal.close(); // Close the loading dialog

            if (response.ok && result.s) {
                Swal.fire({
                    title: 'Berhasil!',
                    text: 'Dokumen BAST berhasil diupload',
                    icon: 'success',
                    confirmButtonColor: '#0d6efd'
                });

                // Refresh data after successful upload
                handleGetData();
                handleCloseProsesMutasiModal();
            } else {
                Swal.fire({
                    title: 'Gagal!',
                    text: result.m || 'Gagal mengupload dokumen BAST',
                    icon: 'error',
                    confirmButtonColor: '#0d6efd'
                });
            }
        } catch (error) {
            console.error('Error uploading BAST file:', error);
            Swal.close(); // Close the loading dialog
            Swal.fire({
                title: 'Error!',
                text: 'Terjadi kesalahan saat mengupload dokumen BAST',
                icon: 'error',
                confirmButtonColor: '#0d6efd'
            });
        }
    };

    const handleUploadSubmit = async (e) => {
        e.preventDefault();

        if (!uploadFile) {
            alert('Silakan pilih file terlebih dahulu');
            return;
        }

        if (!nomorSurat.trim()) {
            alert('Silakan masukkan Nomor Surat Permohonan');
            return;
        }

        if (!tglSurat.trim()) {
            alert('Silakan masukan tgl surat');
            return;
        }

        // Show loading indicator using SweetAlert
        Swal.fire({
            title: 'Mengupload dokumen...',
            text: 'Mohon tunggu sebentar, dokumen sedang diproses',
            allowOutsideClick: false,
            allowEscapeKey: false,
            showConfirmButton: false,
            didOpen: () => {
                Swal.showLoading();
            }
        });

        try {
            const formData = new FormData();
            formData.append('TEMPLATE', currentUploadType);
            formData.append('NOMOR_SURAT', nomorSurat);
            formData.append('FILE_TEMPLATE', uploadFile);
            formData.append('TANGGAL_SURAT', tglSurat);
            formData.append('ID_ALIH_STATUS', currentAlihStatusId);

            const param = {
                method: 'POST',
                headers: {
                    'REST-TOKEN': STATE_AUTH.token,
                    'REST-ID-OPD': STATE_AUTH.id_opd
                },
                body: formData
            };

            const response = await fetch(HOST + '/alih_status/update_template', param);
            const result = await response.json();

            Swal.close(); // Close the loading dialog

            if (response.ok && result.s) {
                Swal.fire({
                    title: 'Berhasil!',
                    text: 'Dokumen berhasil diupload',
                    icon: 'success',
                    confirmButtonColor: '#0d6efd'
                });

                // Refresh data after successful upload
                handleGetData();
                handleCloseUploadModal();
            } else {
                Swal.fire({
                    title: 'Gagal!',
                    text: result.m || 'Gagal mengupload dokumen',
                    icon: 'error',
                    confirmButtonColor: '#0d6efd'
                });
            }
        } catch (error) {
            console.error('Error uploading file:', error);
            Swal.close(); // Close the loading dialog
            Swal.fire({
                title: 'Error!',
                text: 'Terjadi kesalahan saat mengupload dokumen',
                icon: 'error',
                confirmButtonColor: '#0d6efd'
            });
        }
    };

    const handleDownloadDocument = async ({ items, template }) => {

        // Show loading with progress
        Swal.fire({
            title: 'Memproses...',
            text: 'Sedang mengunduh dokumen, mohon tunggu sebentar',
            allowOutsideClick: false,
            allowEscapeKey: false,
            showConfirmButton: false,
            didOpen: () => {
                Swal.showLoading();
            }
        });

        try {
            const fd = new FormData();
            fd.append('ID_ALIH_STATUS', items.id_alih_status);
            fd.append('OPD_ASAL', STATE_AUTH.nama_opd);
            fd.append('OPD_TUJUAN', data_opd.find(opd => opd.id === data_alih_status.find(item => item.id_alih_status === items.id_alih_status)?.id_opd_tujuan)?.opd || '');
            fd.append('ID_OPD_TUJUAN', items.id_opd_tujuan);
            fd.append('ID_KENDARAAN', items.id_kendaraan);
            fd.append('DATA_LAIN', JSON.stringify(items));

            const req = await fetch(HOST + '/alih_status/cetak/' + template, {
                method: 'POST',
                headers: {
                    'REST-TOKEN': STATE_AUTH.token,
                    'REST-ID-OPD': STATE_AUTH.id_opd
                },
                body: fd
            });

            // Close the loading dialog
            Swal.close();

            if (!req.ok) {
                // Handle 4xx and 5xx errors
                if (req.status >= 400 && req.status < 600) {
                    let errorMessage = 'Gagal mengunduh dokumen';
                    try {
                        const errorResponse = await req.json();
                        errorMessage = errorResponse.m || errorResponse.message || errorMessage;
                    } catch (e) {
                        // If response is not JSON, use default error message
                        errorMessage = `Gagal mengunduh dokumen. Kode error: ${req.status}`;
                    }

                    Swal.fire({
                        title: 'Gagal!',
                        text: errorMessage,
                        icon: 'error',
                        confirmButtonColor: '#0d6efd'
                    });
                }
                return;
            }

            // --- Ambil nama file dari header ---

            const disposition = req.headers.get('Content-Disposition');
            let filename = "dokumen.docx";

            if (disposition) {
                // 1. Utamakan filename* (UTF-8)
                const utfMatch = disposition.match(/filename\*=UTF-8''([^;]+)/);
                if (utfMatch && utfMatch[1]) {
                    filename = decodeURIComponent(utfMatch[1]);
                } else {
                    // 2. Fallback ke filename="....."
                    const normalMatch = disposition.match(/filename="([^"]+)"/);
                    if (normalMatch && normalMatch[1]) {
                        filename = normalMatch[1];
                    }
                }
            }

            // --- Proses download ---
            const blob = await req.blob();
            const url = window.URL.createObjectURL(blob);
            const a = document.createElement("a");
            a.href = url;
            a.download = filename; // ← nama dari server
            a.click();

            window.URL.revokeObjectURL(url);

        } catch (error) {
            // Close the loading dialog if there's an error
            Swal.close();

            // Show error notification
            Swal.fire({
                title: 'Gagal!',
                text: 'Terjadi kesalahan saat mengunduh dokumen: ' + error.message,
                icon: 'error',
                confirmButtonColor: '#0d6efd'
            });
        }
    };

    return (
        <main>
            <div className="container-fluid">

                <div className="row mt-3">
                    <div className="col-md-12">
                        <h3><strong><i className='fa fa-user-alt'></i> ALIH STATUS KENDARAAN KELUAR</strong></h3>
                    </div>
                </div>
                <hr />
                <Button variant='success' size='sm' onClick={() => setShowTransferModal(true)}>
                    <FaPlus /> Buat Pengalihan Kendaraan
                </Button>
                <hr />
                <div className="row mt-2">
                    <div className="table-responsive">
                        {loading ? (
                            <div className="d-flex justify-content-center align-items-center" style={{ height: '200px' }}>
                                <div className="spinner-border text-primary" role="status">
                                    <span className="visually-hidden">Loading...</span>
                                </div>
                            </div>
                        ) : (
                            <table className="tb-daftar-dinas mt-1">
                                <thead>
                                    <tr>
                                        <th>No</th>
                                        <th>Opd Asal</th>
                                        <th>Opd Tujuan</th>
                                        <th>Status</th>
                                        <th></th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {data_alih_status.map((item, index) => (
                                        <React.Fragment key={item.id_alih_status}>
                                            <tr>
                                                <td>{index + 1}</td>
                                                <td>{item.opd_asal}</td>
                                                <td>{item.opd_tujuan}</td>
                                                <td>
                                                    <Badge bg={
                                                        item.status === 'pending' || item.status === 'diajukan' ? 'warning' :
                                                            item.status === 'menerima' ? 'info' :
                                                                item.status === 'disetujui' ? 'success' :
                                                                    item.status === 'menolak' || item.status === 'rejected' ? 'danger' : 'secondary'
                                                    }>
                                                        {item.status.charAt(0).toUpperCase() + item.status.slice(1)}
                                                    </Badge>
                                                </td>
                                                <td className='text-center'>
                                                    <ButtonGroup>
                                                        <Button size='sm' variant='info' onClick={() => handleViewDocuments(index, 'kendaraan')}>
                                                            Daftar Kendaraan
                                                        </Button>
                                                        <Button
                                                            size='sm'
                                                            variant='primary'
                                                            onClick={() => handleViewDocuments(index, 'dokumen')}
                                                        >
                                                            Lihat Dokumen
                                                        </Button>
                                                        {
                                                            item.status === 'selesai_mutasi'
                                                                ?
                                                                <Button
                                                                    size='sm'
                                                                    variant={'outline-success'}
                                                                    disabled={true}
                                                                >
                                                                    <FaCheck className="text-success" size={20} title="Mutasi Selesai" /> Proses Mutasi Selesai
                                                                </Button>
                                                                :
                                                                <Button
                                                                    size='sm'
                                                                    variant={isDocumentComplete(item) ? 'success' : 'secondary'}
                                                                    disabled={!isDocumentComplete(item)}
                                                                    onClick={() => handleOpenProsesMutasiModal(item)}
                                                                >
                                                                    Proses Mutasi
                                                                </Button>
                                                        }
                                                    </ButtonGroup>
                                                </td>
                                            </tr>
                                            {expandedRow === index && viewType === 'kendaraan' && (
                                                <tr>
                                                    <td colSpan="7">
                                                        <Card>
                                                            <Card.Header>
                                                                <h5><FaCarAlt /> Daftar Kendaraan</h5>
                                                            </Card.Header>
                                                            <Card.Body>
                                                                <div className="table-responsive">
                                                                    <table className="tb-daftar-dinas mt-1">
                                                                        <thead>
                                                                            <tr>
                                                                                <th>No</th>
                                                                                <th>Merk/Type</th>
                                                                                <th>Nomor Polisi</th>
                                                                                <th>Jenis Kendaraan</th>
                                                                                <th>Status Kondisi</th>
                                                                                <th>Status Barang</th>
                                                                            </tr>
                                                                        </thead>
                                                                        <tbody>
                                                                            {item.daftar_kendaraan && item.daftar_kendaraan.length > 0 ? (
                                                                                item.daftar_kendaraan.map((kendaraan, kIdx) => (
                                                                                    <tr key={kendaraan.id}>
                                                                                        <td>{kIdx + 1}</td>
                                                                                        <td>{kendaraan.merk_type}</td>
                                                                                        <td>{kendaraan.no_polisi}</td>
                                                                                        <td>{kendaraan.sub_jenis}</td>
                                                                                        <td>
                                                                                            <Badge bg={
                                                                                                kendaraan.status_kondisi === 'baik' ? 'success' :
                                                                                                    kendaraan.status_kondisi === 'rusak_ringan' ? 'warning' :
                                                                                                        kendaraan.status_kondisi === 'rusak_berat' ? 'danger' : 'secondary'
                                                                                            }>
                                                                                                {kendaraan.status_kondisi}
                                                                                            </Badge>
                                                                                        </td>
                                                                                        <td>
                                                                                            <Badge bg={
                                                                                                kendaraan.status_barang === 'tersedia' ? 'success' :
                                                                                                    kendaraan.status_barang === 'dipinjam' ? 'info' :
                                                                                                        kendaraan.status_barang === 'dijual' ? 'secondary' : 'warning'
                                                                                            }>
                                                                                                {kendaraan.status_barang}
                                                                                            </Badge>
                                                                                        </td>
                                                                                    </tr>
                                                                                ))
                                                                            ) : (
                                                                                <tr>
                                                                                    <td colSpan="8" className="text-center">Tidak ada kendaraan</td>
                                                                                </tr>
                                                                            )}
                                                                        </tbody>
                                                                    </table>
                                                                </div>
                                                            </Card.Body>
                                                        </Card>
                                                    </td>
                                                </tr>
                                            )}
                                            {expandedRow === index && viewType === 'dokumen' && (
                                                <tr>
                                                    <td colSpan="7">
                                                        <Card>
                                                            <Card.Header>
                                                                <h5><FaFileAlt /> Daftar Dokumen</h5>
                                                            </Card.Header>
                                                            <Card.Body>
                                                                <div className="row text-center">
                                                                    {/* Dokumen Permohonan Setda */}
                                                                    <div className="col-12 col-md-6 col-lg-3 mb-3">
                                                                        <Card className="p-3 h-100 d-flex flex-column align-items-center justify-content-between">
                                                                            <h6 className="text-small">Permohonan</h6>
                                                                            <div className="d-flex flex-column align-items-center">
                                                                                {item.dok_permohonan_setda ? (
                                                                                    <>
                                                                                        <div className="mb-2">
                                                                                            {getDocumentIcon(item.dok_permohonan_setda)}
                                                                                        </div>
                                                                                        <FaCheck className="text-success" size={20} style={{ position: 'absolute', top: 0, right: 0 }} />
                                                                                    </>
                                                                                ) : (
                                                                                    <div style={{ width: 100, height: 100, border: '2px dashed #ccc', borderRadius: '5px', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                                                                                        <span className="text-muted">-</span>
                                                                                    </div>
                                                                                )}
                                                                                {
                                                                                    item.dok_ketersediaan_menerima
                                                                                        ?
                                                                                        <>
                                                                                            <div className="mt-2">
                                                                                                {item.dok_permohonan_setda ? (
                                                                                                    <a
                                                                                                        href={HOST + '/' + item.dok_permohonan_setda}
                                                                                                        target="_blank"
                                                                                                        rel="noreferrer"
                                                                                                        className="btn btn-sm btn-outline-primary me-1"
                                                                                                    >
                                                                                                        <FaEye /> Lihat
                                                                                                    </a>
                                                                                                ) : (
                                                                                                    <Button size="sm" variant="outline-secondary" className="me-1" onClick={() => handleDownloadDocument(
                                                                                                        {
                                                                                                            items: item,
                                                                                                            template: 'template_1',
                                                                                                        })
                                                                                                    }>
                                                                                                        Download
                                                                                                    </Button>
                                                                                                )}
                                                                                                {item.dok_permohonan_setda ? null : (
                                                                                                    <Button size="sm" variant="outline-success" onClick={() => handleOpenUploadModal(item.id_alih_status, 'template_1')}>
                                                                                                        <FaUpload /> Upload
                                                                                                    </Button>
                                                                                                )}
                                                                                            </div>
                                                                                            <div className="mt-1">
                                                                                                {item.no_surat_dok_permohonan_setda && (
                                                                                                    <small className="text-muted">
                                                                                                        No. Surat: {item.no_surat_dok_permohonan_setda}
                                                                                                    </small>
                                                                                                )}
                                                                                            </div>
                                                                                        </>
                                                                                        :
                                                                                        <div className='mt-2'>
                                                                                            <span>(Menunggu dokumen kesediaan menerima )</span>
                                                                                        </div>
                                                                                }
                                                                            </div>
                                                                        </Card>
                                                                    </div>

                                                                    {/* Dokumen Ketersediaan Menerima */}
                                                                    <div className="col-12 col-md-6 col-lg-3 mb-3">
                                                                        <Card className="p-3 h-100 d-flex flex-column align-items-center justify-content-between">
                                                                            <h6 className="text-small">Kesediaan Menerima</h6>
                                                                            <div className="d-flex flex-column align-items-center">
                                                                                {item.dok_ketersediaan_menerima ? (
                                                                                    <>
                                                                                        <div className="mb-2">
                                                                                            {getDocumentIcon(item.dok_ketersediaan_menerima)}
                                                                                        </div>
                                                                                        <FaCheck className="text-success" size={20} style={{ position: 'absolute', top: 0, right: 0 }} />
                                                                                    </>
                                                                                ) : (
                                                                                    <div style={{ width: 100, height: 100, border: '2px dashed #ccc', borderRadius: '5px', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                                                                                        <span className="text-muted">-</span>
                                                                                    </div>
                                                                                )}
                                                                                <div className="mt-2">
                                                                                    {item.dok_ketersediaan_menerima ? (
                                                                                        <a
                                                                                            href={HOST + '/' + item.dok_ketersediaan_menerima}
                                                                                            target="_blank"
                                                                                            rel="noreferrer"
                                                                                            title={HOST + item.dok_ketersediaan_menerima}
                                                                                            className="btn btn-sm btn-outline-primary me-1"
                                                                                        >
                                                                                            <FaEye /> Lihat
                                                                                        </a>
                                                                                    ) : (
                                                                                        <span>(Dokumen belum diupload)</span>
                                                                                    )}
                                                                                </div>
                                                                                <div className="mt-1">
                                                                                    {item.no_surat_dok_ketersediaan_menerima && (
                                                                                        <small className="text-muted">
                                                                                            No. Surat: {item.no_surat_dok_ketersediaan_menerima}
                                                                                        </small>
                                                                                    )}
                                                                                </div>
                                                                            </div>
                                                                        </Card>
                                                                    </div>

                                                                    {/* Dokumen Persetujuan */}
                                                                    <div className="col-12 col-md-6 col-lg-3 mb-3">
                                                                        <Card className="p-3 h-100 d-flex flex-column align-items-center justify-content-between">
                                                                            <h6 className="text-small">Persetujuan</h6>
                                                                            <div className="d-flex flex-column align-items-center">
                                                                                {item.dok_persetujuan ? (
                                                                                    <>
                                                                                        <div className="mb-2">
                                                                                            {getDocumentIcon(item.dok_persetujuan)}
                                                                                        </div>
                                                                                        <FaCheck className="text-success" size={20} style={{ position: 'absolute', top: 0, right: 0 }} />
                                                                                    </>
                                                                                ) : (
                                                                                    <div style={{ width: 100, height: 100, border: '2px dashed #ccc', borderRadius: '5px', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                                                                                        <span className="text-muted">-</span>
                                                                                    </div>
                                                                                )}
                                                                                {
                                                                                    item.dok_permohonan_setda
                                                                                        ?
                                                                                        <>
                                                                                            <div className="mt-2">
                                                                                                {item.dok_persetujuan ? (
                                                                                                    <a
                                                                                                        href={HOST + '/' + item.dok_persetujuan}
                                                                                                        target="_blank"
                                                                                                        rel="noreferrer"
                                                                                                        className="btn btn-sm btn-outline-primary me-1"
                                                                                                    >
                                                                                                        <FaEye /> Lihat
                                                                                                    </a>
                                                                                                ) : (
                                                                                                    <Button size="sm" variant="outline-secondary" className="me-1" onClick={() => handleDownloadDocument(
                                                                                                        {
                                                                                                            items: item,
                                                                                                            template: 'template_3',
                                                                                                        })
                                                                                                    }>
                                                                                                        Download
                                                                                                    </Button>
                                                                                                )}
                                                                                                {item.dok_persetujuan ? null : (
                                                                                                    <Button size="sm" variant="outline-success" onClick={() => handleOpenUploadModal(item.id_alih_status, 'template_3')}>
                                                                                                        <FaUpload /> Upload
                                                                                                    </Button>
                                                                                                )}
                                                                                            </div>
                                                                                            <div className="mt-1">
                                                                                                {item.no_surat_persetujuan && (
                                                                                                    <small className="text-muted">
                                                                                                        No. Surat: {item.no_surat_persetujuan}
                                                                                                    </small>
                                                                                                )}
                                                                                            </div>
                                                                                        </>
                                                                                        :
                                                                                        <div className='mt-2'>
                                                                                            <span>(Menunggu dokumen Permohonan )</span>
                                                                                        </div>
                                                                                }
                                                                            </div>
                                                                        </Card>
                                                                    </div>

                                                                    {/* Dokumen BAST */}
                                                                    <div className="col-12 col-md-6 col-lg-3 mb-3">
                                                                        <Card className="p-3 h-100 d-flex flex-column align-items-center justify-content-between">
                                                                            <h6 className="text-small">BAST</h6>
                                                                            <div className="d-flex flex-column align-items-center">
                                                                                {item.dok_bast ? (
                                                                                    <>
                                                                                        <div className="mb-2">
                                                                                            {getDocumentIcon(item.dok_bast)}
                                                                                        </div>
                                                                                        <FaCheck className="text-success" size={20} style={{ position: 'absolute', top: 0, right: 0 }} />
                                                                                    </>
                                                                                ) : (
                                                                                    <div style={{ width: 100, height: 100, border: '2px dashed #ccc', borderRadius: '5px', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                                                                                        <span className="text-muted">-</span>
                                                                                    </div>
                                                                                )}
                                                                                {
                                                                                    item.dok_persetujuan
                                                                                        ?
                                                                                        <>
                                                                                            <div className="mt-2">
                                                                                                {item.dok_bast ? (
                                                                                                    <a
                                                                                                        href={HOST + '/' + item.dok_bast}
                                                                                                        target="_blank"
                                                                                                        rel="noreferrer"
                                                                                                        className="btn btn-sm btn-outline-primary me-1"
                                                                                                    >
                                                                                                        <FaEye /> Lihat
                                                                                                    </a>
                                                                                                ) : (
                                                                                                    <Button size="sm" variant="outline-secondary" className="me-1" onClick={() => handleDownloadDocument(
                                                                                                        {
                                                                                                            items: item,
                                                                                                            template: 'template_4',
                                                                                                        })
                                                                                                    }>
                                                                                                        Download
                                                                                                    </Button>
                                                                                                )}
                                                                                                {item.dok_bast ? null : (
                                                                                                    <Button size="sm" variant="outline-success" onClick={() => handleOpenUploadModal(item.id_alih_status, 'template_4')}>
                                                                                                        <FaUpload /> Upload
                                                                                                    </Button>
                                                                                                )}
                                                                                            </div>
                                                                                        </>
                                                                                        :
                                                                                        <div className='mt-2'>
                                                                                            <span>(Menunggu dokumen Persetujuan )</span>
                                                                                        </div>
                                                                                }
                                                                                <div className="mt-1">
                                                                                    {item.no_surat_bast && (
                                                                                        <small className="text-muted">
                                                                                            No. Surat: {item.no_surat_bast}
                                                                                        </small>
                                                                                    )}
                                                                                </div>
                                                                            </div>
                                                                        </Card>
                                                                    </div>
                                                                </div>
                                                            </Card.Body>
                                                        </Card>
                                                    </td>
                                                </tr>
                                            )}
                                        </React.Fragment>
                                    ))}
                                </tbody>
                            </table>
                        )}
                    </div>
                </div>
            </div>

            {/* Vehicle Transfer Modal */}
            <Modal show={showTransferModal} onHide={handleClose} size="lg">
                <Modal.Header closeButton>
                    <Modal.Title>Form Pengalihan Kendaraan</Modal.Title>
                </Modal.Header>
                <Form onSubmit={handleSubmit}>
                    <Modal.Body>
                        {/* OPD Selection */}
                        <Form.Group className="mb-3">
                            <Form.Label>Pilih OPD Tujuan</Form.Label>
                            <Form.Select
                                size="sm"
                                value={selectedOpd}
                                onChange={(e) => setSelectedOpd(e.target.value)}
                                required
                            >
                                <option value="">-- Pilih OPD --</option>
                                {data_opd.map(opd => (
                                    opd.id === STATE_AUTH.id_opd ? null : (
                                        <option key={opd.id} value={opd.id}>
                                            {opd.opd}
                                        </option>)
                                ))}
                            </Form.Select>
                        </Form.Group>

                        {/* Vehicle Selection */}
                        <Form.Group className="mb-3">
                            <Form.Label>Pilih Daftar Kendaraan</Form.Label>
                            <div className="table-responsive" style={{ maxHeight: '300px', overflowY: 'auto' }}>
                                <table className="tb-daftar-dinas mt-1">
                                    <thead className="sticky-top bg-white">
                                        <tr>
                                            <th width="5%">#</th>
                                            <th>Nama Barang</th>
                                            <th>No. Polisi</th>
                                            <th>Merk/Type</th>
                                            <th>Jenis</th>
                                            <th width="5%">Pilih</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {data_kendaraan.filter(v => !daftar_kendaraan_teralih.includes(v.id)).map((vehicle, index) => (
                                            <tr key={vehicle.id} onClick={() => handleVehicleSelect(vehicle.id)} style={{ cursor: 'pointer' }}>
                                                <td>{index + 1}</td>
                                                <td>{vehicle.nama_barang}</td>
                                                <td>{vehicle.no_polisi}</td>
                                                <td>{vehicle.merk_type}</td>
                                                <td>{vehicle.jenis}</td>
                                                <td>
                                                    <Form.Check
                                                        type="checkbox"
                                                        checked={selectedVehicles.includes(vehicle.id)}
                                                        onChange={() => handleVehicleSelect(vehicle.id)}
                                                        id={`vehicle-${vehicle.id}`}
                                                    />
                                                </td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>
                            </div>

                            {/* Selected Vehicles Summary */}
                            {selectedVehicles.length > 0 && (
                                <div className="mt-3">
                                    <h6>Kendaraan Terpilih ({selectedVehicles.length})</h6>
                                    <div className="table-responsive">
                                        <table className="tb-daftar-dinas mt-1">
                                            <thead>
                                                <tr>
                                                    <th width="5%">#</th>
                                                    <th>Nama Barang</th>
                                                    <th>No. Polisi</th>
                                                    <th>Merk/Type</th>
                                                    <th>Jenis</th>
                                                    <th width="5%"></th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {data_kendaraan
                                                    .filter(vehicle => selectedVehicles.includes(vehicle.id))
                                                    .map((vehicle, index) => (
                                                        <tr key={vehicle.id}>
                                                            <td>{index + 1}</td>
                                                            <td>{vehicle.nama_barang}</td>
                                                            <td>{vehicle.no_polisi}</td>
                                                            <td>{vehicle.merk_type}</td>
                                                            <td>{vehicle.jenis}</td>
                                                            <td>
                                                                <FaTrashAlt onClick={() => handleVehicleSelect(vehicle.id)} style={{ cursor: 'pointer' }} color='red' />
                                                            </td>
                                                        </tr>
                                                    ))}
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            )}
                        </Form.Group>

                        {/* Reason for Transfer */}
                        <Form.Group className="mb-3">
                            <Form.Label>Alasan Pengalihan</Form.Label>
                            <Form.Control
                                as="textarea"
                                rows={3}
                                value={reason}
                                onChange={(e) => setReason(e.target.value)}
                                placeholder="Masukkan alasan pengalihan kendaraan"
                                required
                            />
                        </Form.Group>
                    </Modal.Body>
                    <Modal.Footer>
                        <Button variant="secondary" onClick={handleClose}>
                            Batal
                        </Button>
                        <Button
                            variant="primary"
                            type="submit"
                        >
                            Ajukan Pengalihan
                        </Button>
                    </Modal.Footer>
                </Form>
            </Modal>

            {/* Upload Document Modal */}
            <Modal show={showUploadModal} onHide={handleCloseUploadModal} size="lg" backdrop="static">
                <Modal.Header closeButton>
                    <Modal.Title>Upload Dokumen</Modal.Title>
                </Modal.Header>
                <Form onSubmit={handleUploadSubmit}>
                    <Modal.Body>
                        {
                            currentUploadType === 'template_1' ? <Alert variant="info">Silakan upload dokumen Permohonan Setda.</Alert> :
                                currentUploadType === 'template_3' ? <Alert variant="info">Silakan upload dokumen Persetujuan.</Alert> :
                                    currentUploadType === 'template_4' ? <Alert variant="info">Silakan upload dokumen BAST.</Alert> : null
                        }
                        <Form.Group className="mb-3">
                            <Form.Label>Nomor Surat</Form.Label>
                            <Form.Control
                                type="text"
                                placeholder="Masukkan nomor surat"
                                value={nomorSurat}
                                onChange={(e) => setNomorSurat(e.target.value)}
                                required
                            />
                            <Form.Text className="text-muted">
                                Jika nomor surat lebih dari satu, pisahkan dengan tanda koma. Contoh: 'xxx/xxx/xxx,xxx/xxx/xxx'
                            </Form.Text>
                        </Form.Group>
                        <Form.Group className="mb-3">
                            <Form.Label>Tanggal Surat</Form.Label>
                            <Form.Control
                                type="date"
                                placeholder="Masukkan tanggal surat"
                                value={tglSurat}
                                onChange={(e) => setTglSurat(e.target.value)}
                                required
                            />
                        </Form.Group>
                        <Form.Group className="mb-3">
                            <Form.Label>Pilih File Dokumen</Form.Label>
                            <Form.Control
                                type="file"
                                onChange={handleFileChange}
                                accept=".doc,.docx,.pdf,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document,application/pdf"
                                required
                            />
                            <Form.Text className="text-muted">
                                Format file yang diperbolehkan: DOC, DOCX, atau PDF
                            </Form.Text>
                        </Form.Group>
                    </Modal.Body>
                    <Modal.Footer>
                        <Button variant="secondary" onClick={handleCloseUploadModal}>
                            Batal
                        </Button>
                        <Button variant="primary" type="submit">
                            <FaUpload /> Upload Dokumen
                        </Button>
                    </Modal.Footer>
                </Form>
            </Modal>

            {/* Proses Mutasi Upload Modal - BAST only */}
            <Modal show={showProsesMutasiModal} onHide={handleCloseProsesMutasiModal} size="lg" backdrop="static">
                <Modal.Header closeButton>
                    <Modal.Title>Upload Dokumen BAST - Proses Mutasi</Modal.Title>
                </Modal.Header>
                <Form onSubmit={handleProsesMutasiSubmit}>
                    <Modal.Body>
                        <Alert variant="info">
                            Silakan upload dokumen BAST (Berita Acara Serah Terima) untuk menyelesaikan proses mutasi kendaraan.
                        </Alert>
                        <Form.Group className="mb-3">
                            <Form.Label>Pilih File Dokumen BAST</Form.Label>
                            <Form.Control
                                type="file"
                                onChange={handleProsesMutasiFileChange}
                                accept=".doc,.docx,.pdf,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document,application/pdf"
                                required
                            />
                            <Form.Text className="text-muted">
                                Format file yang diperbolehkan: DOC, DOCX, atau PDF
                            </Form.Text>
                        </Form.Group>
                    </Modal.Body>
                    <Modal.Footer>
                        <Button variant="secondary" onClick={handleCloseProsesMutasiModal}>
                            Batal
                        </Button>
                        <Button variant="primary" type="submit">
                            <FaUpload /> Upload BAST
                        </Button>
                    </Modal.Footer>
                </Form>
            </Modal>
        </main>

    )
}

export default Opd_alih_status_kendaraan_keluar